module.exports = __webpack_public_path__ + "static/unfold_icon_2-75bc5872eb14c09431894bef89fb4588.png";